export function setRightColumnAfmAndMidSearched(afmSearched, midSearched, tidSearched) {
    return {
        type: "RIGHT_COLUMN_MID_SEARCH",
        afmSearched: afmSearched,
        midSearched: midSearched,
        tidSearched: tidSearched
    }
}
